export const TYPE_VENTE = 'Vente';
export const TYPE_ACHAT = 'Achat';
export const TYPE_REGLEMENT = 'Reglement';
export const TYPE_PAIEMENT = 'Paiement';
export const TYPE_OD = 'Od';

export const LISTE_TYPE = [
  { code: TYPE_VENTE, libelle: 'listeJournalEcriture.typeEcriture.vente' },
  { code: TYPE_REGLEMENT, libelle: 'listeJournalEcriture.typeEcriture.reglement' },
  { code: TYPE_ACHAT, libelle: 'listeJournalEcriture.typeEcriture.achat' },
  { code: TYPE_PAIEMENT, libelle: 'listeJournalEcriture.typeEcriture.paiement' },
  { code: TYPE_OD, libelle: 'listeJournalEcriture.typeEcriture.od' },
];

export const EXPORT_EXCEL_ECRITURE_COMPTABLE = 'ecriturecomptable';
